export enum httpHeaders {
  X_CORRELATION_ID = 'x-correlation-id',
  X_RECAPTCHA_TOKEN = 'x-recaptcha-token',
}

export interface HttpHeaders {
  x_correlation_id: string;
  x_recaptcha_token: string;
}

export enum AuthHeaderNames {
  REQUEST_SOURCE = 'request-source',
  REQUEST_ACTION = 'request-action',
  CLIENT = 'wl-client',
}
